import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Paragraph from 'src/elements/typography/paragraph';

import { ButtonContentfulModel } from '../../api/models/Button';
import LinkBranded from '../../elements/links/Link.branded';
import Heading from '../../elements/typography/heading';
import { CallToActionContainer, StyledCTAContainerProps } from './callToAction.styles';

export interface CallForActionProps extends StyledCTAContainerProps{
  title: string;
  description: string;
  buttonSize?: string;
  actionButton: ButtonContentfulModel;
}

const CallForActionWithDescription = ({ title, description, paddingTop, buttonSize, actionButton }: CallForActionProps): JSX.Element => {
  return (
    <FadeInAnimationWrapper>
      <CallToActionContainer paddingTop={paddingTop || '4rem'} rowGap={'2rem'}>
        <Heading text={title}
          size="2.785em"
          sizeMd="2em"
          sizeSm="1.5em"
          align="center" />
        <Paragraph
          text={description}
          size="1.5em"
          sizeSm="1.125em"
          align="center"
          weight="light"
        />
        <LinkBranded
          text={actionButton.text}
          weight="normal"
          justify="center"
          size={buttonSize || '1.25em'}
          url={actionButton.url}
          caption={actionButton.helpText}
          captionJustify="center"
        />
      </CallToActionContainer>
    </FadeInAnimationWrapper>
  )
}

export default CallForActionWithDescription;
